import { render, staticRenderFns } from "./LocaleForm.vue?vue&type=template&id=288cfa89&"
import script from "./LocaleForm.vue?vue&type=script&lang=ts&"
export * from "./LocaleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports